<template>
  <v-container fluid id="what-is-kitty-club-page">
    <img id="planet" :src="require(`../assets/planet.png`)" alt="Planet" />
    <img id="orb-1" :src="require(`../assets/orb-2.svg`)" alt="Orb" />
    <v-row class="mt-12 justify-center">
      <v-col xs="8" sm="10" md="8" lg="7">
        <h1 id="title">What is Kitty Club?</h1>
        <img
          class="mt-n3"
          :src="require(`../assets/gold-line.svg`)"
          alt="Cats line"
        />
        <div id="paragraphs">
          <p id="paragraph" class="mt-n7">
            Bored Bunny is a collection of 4,999 unique 3D well-designed Bunnies
            united together to get on the Ethereum Blockchain Each Bored Bunny
            is unique and exclusive based on a hundred traits. The objective is
            to build the strongest community and project around NFTs.
          </p>
          <p id="paragraph" class="mb-12">
            Entering into the Bored Bunny Community means joining a family full
            of investors and nft enthusiasts who believe in the future of
            Cryptocurrencies and the blockchain technology.
          </p>
        </div>

        <a href="#" class="glow-button"
          ><v-icon
            id="icon-button"
            large
            color="#FFFFFF"
            class="mr-2 .d-none .d-md-flex .d-lg-none"
            >mdi-discord</v-icon
          >Join our discord</a
        >
      </v-col>
      <img
        id="cats-line"
        :src="require(`../assets/cats-line.png`)"
        alt="Cats line"
      />
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "WhatIs",

  data: () => ({}),
};
</script>
<style scoped>
#cats-line {
  z-index: 0;
  position: absolute;
  bottom: 2vh;
  width: 80vw;
}

.glow-button {
  text-decoration: none;
  color: white !important;
  background: linear-gradient(
    135deg,
    rgba(217, 173, 89, 1) 0%,
    rgba(162, 128, 62, 1) 100%
  );
  padding: 15px 40px;
  border-radius: 4px;
  font-weight: normal;
  box-shadow: 0 0 15px rgb(255, 255, 255, 0.4) !important;
  font-size: 2vw !important;
  cursor: pointer;
}
#title {
  color: white !important;
  font-weight: 500 !important;
  font-size: 5vw !important;
  line-height: 5vw !important;
}
#paragraph {
  color: white !important;
  font-weight: 300 !important;
  font-size: 1.2vw !important;
  line-height: 1.6vw !important;
}
#what-is-kitty-club-page {
  color: white;
  height: calc(100vh - 80px);
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 1) 0%,
    rgba(28, 27, 27, 1) 100%
  );
  text-align: center;
  position: relative;
  overflow: hidden;
}
#planet {
  position: absolute;
  top: -5%;
  left: 0;
  z-index: 0;
  opacity: 0.8;
}
#orb-1 {
  position: absolute;
  right: -20%;
  bottom: -45%;
  z-index: 0;
  opacity: 0.3;
}
@media screen and (max-width: 961px) {
  #what-is-kitty-club-page {
    height: calc(100vh - 56px);
    width: 100vw;
    margin-top: 0px !important;
  }
  #paragraph {
    font-size: 2vw !important;
    line-height: 2vw !important;
  }
}

@media screen and (max-width: 821px) {
  #title {
    font-size: 8vw !important;
    line-height: 9vw !important;
    margin-top: 50px;
  }

  #paragraph {
    font-size: 3vw !important;
    line-height: 3.5vw !important;
  }

  .glow-button {
    font-size: 4vw !important;
  }
  #cats-line {
    right: -72vw;
    width: 170vw;
    bottom: 10vh;
  }
}

@media screen and (max-width: 600px) {
  #title {
    margin-top: 0px;
  }
}
@media screen and (max-width: 426px) {
  #cats-line {
    width: 270vw;
    right: -160vw;
  }
  #paragraph {
    font-size: 4.5vw !important;
    line-height: 5vw !important;
  }
}
@media screen and (max-width: 376px) {
  #paragraph {
    font-size: 3vw !important;
    line-height: 3vw !important;
  }
  #title {
    font-size: 8vw !important;
    line-height: 8vw !important;
  }
  .numbers {
    font-size: 4vw;
  }
  .numbers h2 {
    font-size: 6vw !important;
  }
  #cats-group {
    right: 3%;
    width: 100vw;
  }
  #orb-2 {
    right: 3%;
    width: 100vw;
  }
}
</style>
